var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxAndroidNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3412 2.66025C4.09446 2.91208 3.95166 3.30417 3.95166 3.81194V21.9237C3.95166 22.4315 4.09446 22.8236 4.3412 23.0754L4.4021 23.1307L14.8116 12.9856V12.746L4.4021 2.60087L4.3412 2.66025Z",
    fill: "url(#paint0_linear_438_517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.276 16.369L14.8101 12.9856V12.746L18.2802 9.36261L18.3579 9.40663L22.4675 11.6865C23.6404 12.3335 23.6404 13.3981 22.4675 14.0492L18.3579 16.325L18.276 16.369V16.369Z",
    fill: "url(#paint1_linear_438_517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.36 16.325L14.8122 12.8658L4.3418 23.0754C4.73134 23.4747 5.36657 23.5228 6.08896 23.1236L18.36 16.325",
    fill: "url(#paint2_linear_438_517)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.36 9.40667L6.08896 2.60809C5.36657 2.21293 4.73134 2.26105 4.3418 2.6603L14.8122 12.8658L18.36 9.40667Z",
    fill: "url(#paint3_linear_438_517)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_517",
    x1: 13.8873,
    y1: 22.1124,
    x2: 0.147247,
    y2: 8.01997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_438_517",
    x1: 23.9948,
    y1: 12.8647,
    x2: 3.6698,
    y2: 12.8647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_438_517",
    x1: 16.4308,
    y1: 10.9853,
    x2: -2.20186,
    y2: -8.1251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_438_517",
    x1: 1.70619,
    y1: 29.1012,
    x2: 10.0265,
    y2: 20.5676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxAndroidNew);
export default __webpack_public_path__ + "static/media/iconsax-android-new.a98c1d3d0969a38cf6e07ab53cf9224b.svg";
export { ForwardRef as ReactComponent };